
<ng-container *ngFor="let activityTuple of activitiesGroupedObs | async">
  <div *ngIf="getActivities(activityTuple)?.length == 1;else multi">
    
    <ss-actor-card-item [activity]="getActivities(activityTuple)[0]"></ss-actor-card-item>

  </div>


  <ng-template #multi>
    <div *ngIf="hideGroupSubject | async;else showGroup" class="flex-column gap-small">
      <ss-actor-card-item
        *ngFor="let activity of getActivities(activityTuple);trackBy:trackById"
        [activity]="activity"
        
      >
      </ss-actor-card-item>
    </div>
    <ng-template #showGroup>
      <div class="primary-background-A200-transparent border-radius-small padding-small border-gray flex-column gap-small">
        <ss-actor-card-item
          *ngFor="let activity of getActivities(activityTuple);trackBy:trackById"
          [activity]="activity"
          
        >
        </ss-actor-card-item>
  
      </div>
    </ng-template>
    

  </ng-template>
  
</ng-container>
